import ObjectPicker from "../object-picker/object-picker";
import { IOneDrivePickerProps } from "./onedrive-picker.props";
import OneDriveCard from "components/common/onedrive-card/onedrive-card";


export default function OneDrivePicker(props: IOneDrivePickerProps) {
    return (
        <ObjectPicker
            getSearchUrl={(search: string, pageNumber: number, pageSize: number) =>
                `/api/onedrives/search?search=${encodeURIComponent(search)}&pageNumber=${pageNumber}&pageSize=${pageSize}`
            }
            onChange={props.onChange}
            model={props.model}
            label={props.label || "ppaOneDrive"}
            readonly={props.readonly}
            objectCard={<OneDriveCard />} />
    );
}